import { render } from "./WorkspaceSettingsSubNav.vue?vue&type=template&id=042aa068&ts=true"
import script from "./WorkspaceSettingsSubNav.vue?vue&type=script&lang=ts"
export * from "./WorkspaceSettingsSubNav.vue?vue&type=script&lang=ts"

import "./WorkspaceSettingsSubNav.vue?vue&type=style&index=0&id=042aa068&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__